/** @jsx jsx */

import { jsx } from '@emotion/core';

import { Link } from '@zapier/design-system';

/*
 * This leverages our custom Link component to perform routing.
 */
function LinkButton(props: React.ComponentProps<typeof Link>) {
  const { href, target, variant = 'primary', ...linkProps } = props;

  return <Link href={href} target={target} variant={variant} {...linkProps} />;
}

export default LinkButton;
